import type { LoadableType } from '@confluence/loadable';
import { LoadableLazy } from '@confluence/loadable';

export const AgentMentionFyiNudgeAsync: LoadableType<{
	visible: boolean;
	agent?: {
		id: string;
		name: string;
	};
}> = LoadableLazy({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-AgentMentionFyiNudge" */ '../src/AgentMentionFyiNudge.tsx'
			)
		).AgentMentionFyiNudge,
});
